module.exports = __webpack_public_path__ + "static/media/a1.59767f36.jpg";